import { getSelectedDepot } from "../selectors/app";
import * as RouteService from "../../services/routes";
import { showNotification } from "./notifications";
import { NotificationType } from "../../features/Notifier";
import { DISMISS } from "../../constants/strings";
import { getRoutesList } from "../selectors/routes";
import RouteStatusDescription from "../../enums/RouteStatusDescription";
import { getErrorMessage } from "../../utils/errors";

export const ROUTES_LOADED = "ROUTES_LOADED";
export const ROUTES_DEPOT_STATS_LOADED = "ROUTES_DEPOT_STATS_LOADED";
export const CHANGE_SELECTED_FILTERS = "CHANGE_SELECTED_FILTERS";
export const SHOW_ROUTE_DETAILS = "SHOW_ROUTE_DETAILS";
export const UPDATE_LIST_ROUTE = "UPDATE_LIST_ROUTE";

export const routesLoaded = (routes) => ({
  type: ROUTES_LOADED,
  payload: routes,
});

export const routesDepotStatsLoaded = (depotStats) => ({
  type: ROUTES_DEPOT_STATS_LOADED,
  payload: depotStats,
});

export const filtersChanged = (filters) => ({
  type: CHANGE_SELECTED_FILTERS,
  payload: filters,
});

export const updateListRoute = (route) => ({
  type: UPDATE_LIST_ROUTE,
  payload: route,
});

export const changeRouteOpportunityTime = (opportunityTime, routeId) => (
  dispatch,
  getState
) => {
  const state = getState();
  const route = getRoutesList(state)[routeId];
  dispatch(
    updateListRoute({
      ...route,
      opportunityTime,
    })
  );
};

export const changeRouteStatus = (routeStatus, routeId) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const depotCode = getSelectedDepot(state);
  const route = getRoutesList(state)[routeId];

  try {
    await RouteService.changeRouteStatus(depotCode, routeStatus, routeId);
    dispatch(
      updateListRoute({
        ...route,
        routeStatus,
        routeStatusDescription: RouteStatusDescription[routeStatus],
      })
    );
  } catch (error) {
    dispatch(
      showNotification({
        type: NotificationType.ACTION,
        message: getErrorMessage(error),
        buttonText: DISMISS,
      })
    );
  }
};

export const successRouteFetch = (data) => async (dispatch) => {
  const mappedRoutes = data.routes.reduce((acc, route) => {
    acc[route.routeId] = route;
    return acc;
  }, {});

  dispatch(routesLoaded(mappedRoutes));
  dispatch(routesDepotStatsLoaded(data.depotStats));
};

export const fetchRoutes = (depotId, sectionId, date, userId) => async (
  dispatch
) => {
  const data = await RouteService.getRoutes(depotId, sectionId, date, userId);
  dispatch(successRouteFetch(data));
};

export const updateRouteInList = (routeId, updatedData) => (
  dispatch,
  getState
) => {
  const state = getState();
  const route = getRoutesList(state)[routeId];
  dispatch(
    updateListRoute({
      ...route,
      ...updatedData,
    })
  );
};
